export default __webpack_public_path__ + "static/media/blank_leaderboardD.26fc55a8.svg";